import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent, IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { CreateEntityButtonComponent } from '@shared/components/create-entity-button/create-entity-button.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';

@Component({
  imports: [BreadcrumbComponent, CreateEntityButtonComponent, TranslateModule],
  selector: 'app-banner-card',
  templateUrl: './banner-card.component.html',
})
export class BannerCardComponent {
  public readonly header = input<string | null>(null);
  public readonly height = input<number | null>(null);
  public readonly headerHeight = input<number | null>(null);
  public readonly backgroundColor = input<string>('transparent');
  public readonly padding = input<string | null>(null);
  public readonly breadcrumbs = input<IBreadcrumb[] | null>(null);
  public readonly addButtonConfiguration = input<ICreateEntityButtonConfiguration | null>(null);
}
